import css from 'styled-jsx/css';
import { screen } from 'components/styles/variables';

const useSearchFilterStyles = css`
  .hide-on-mobile {
    display: none;
  }

  .search-filters-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  @media (min-width: ${screen.lgMin}) {
    .mobile-filter {
      display: none;
    }
  }
`;

export default useSearchFilterStyles;
